// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Custom component
import AutomationProForm from "./components/AutomationProForm";

// @mui components
import SoftBox from "components/SoftBox";

function NewAutoLicense() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <AutomationProForm />
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewAutoLicense;